globalConfigLoaded(function () {
	'use strict';

	angular
		.module('app.setup')
		.controller('supplyChainGeneral', supplyChainGeneral);

	supplyChainGeneral.$inject = ['$rootScope', '$scope', '$timeout', '$q', '$sce', '$translate', 'factorySettingService', 'customerSettingService', 'shortageCriticalityLevelService', 'storeService'];

	function supplyChainGeneral($rootScope, $scope, $timeout, $q, $sce, $translate, factorySettingService, customerSettingService, shortageCriticalityLevelService, storeService) {
		var vm = this;
		var adminConfig = storeService.getState().adminConfig;
		var noneRank = 'NONE';
		var noneLevel = {label: 'None', rank: noneRank};
		vm.showCustomerOrderMetadataLabel = $translate.instant('Show Extra Customer Order Columns') + ' ('  + $translate.instant('Affects all sites for') + ' ' + adminConfig.customer.name + ')';
		vm.customerName = adminConfig.customer.name;
		vm.saveSettings = saveSettings;
		vm.validate = validate;
		vm.trimLeadingZeroes;
		vm.leadTime;
		vm.receivingTime;
		vm.shortageByOrderReport;
		vm.shortgeByOrderDataHorizonInMonths;
		vm.additionalPeggingLogic;
		vm.excludePlannedSupply;
		vm.prRequestedDateIncludesReceivingTime;
		vm.poRequestedDateIncludesReceivingTime;
		vm.generateClearToBuild;
		vm.generateClearToBuildFlattenedReqs;
		vm.clearToBuildHorizonField;
		vm.includingPRsInCTB;
		vm.forceHardPegging;
		vm.clearToBuildWindowDays;
		vm.clearToCommitWindowDays;
		vm.showCustomerOrderMetadata;
		vm.firmBeforePlanned;
		vm.supplyDateToUseInCTB;
		vm.showShortageCriticalityLvls = false;
		vm.isLeanDNAAdmin = $rootScope.authz.isLeanDNAAdmin();
		vm.isSuperAdmin = $rootScope.authz.isSuperAdmin();
		vm.isCustomerAdmin = $rootScope.authz.isCustomerAdmin();
		vm.criticalityLvls = [];
		vm.kpiCriticalityLvl;
		vm.usePoConfirmations;

		vm.shortageByOrderDataHorizonInMonthsOptions = [
			{
				display: 'None',
				value: -1
			},
			{
				display: '1 month',
				value: 1
			},
			{
				display: '3 months',
				value: 3
			},
			{
				display: '6 months',
				value: 6
			},
			{
				display: '12 months',
				value: 12
			}
		];

		init();

		function init() {
			var promiseOne = factorySettingService.getFactorySettings(
				[
					'TRIM_LEADING_ZEROS',
					'PROCUREMENT_LEAD_TIME_DAYS',
					'PROCUREMENT_RECEIVING_TIME_DAYS',
					'SHORTAGE_BY_ORDER_REPORT',
					'PROCUREMENT_GENERATE_SHORTAGE_BY_ORDER_REPORT',
					'SHORTAGE_BY_ORDER_DATA_HORIZON',
					'ADDITIONAL_PEGGING_LOGIC',
					'EXCLUDE_PR_AND_PPOS_FROM_SBO_PEGGING',
					'PR_REQUESTED_DATE_INCLUDES_RECEIVING_TIME',
					'PO_REQUESTED_DATE_INCLUDES_RECEIVING_TIME',
					'DISABLE_UPDATING_COMMIT_DATES_FOR_DELIVERED_POS',
					'MAX_CRITICALITY_RANK_IN_SHORTAGES_KPI',
					'ONLY_INCLUDE_CRITICAL_SHORTAGES_IN_STANDARD_WORK_EMAIL',
					'HIDE_LEANDNA_ACTION_COLUMN',
					'GENERATE_CLEAR_TO_BUILD',
					'GENERATE_CLEAR_TO_BUILD_FLATTENED_REQS',
					'CLEAR_TO_BUILD_HORIZON_FIELD',
					'INCLUDING_PRS_IN_CTB',
					'MANUFACTURED_PART_STATUS_IN_MULTI_LEVEL_CTB',
					'CLEAR_TO_BUILD_PERCENT_WINDOW_DAYS',
					'CLEAR_TO_COMMIT_PERCENT_WINDOW_DAYS',
					'FORCE_HARD_PEGGING',
					'PEG_FIRM_BEFORE_PLANNED_CTB',
					'SUPPLY_DATE_TO_USE_IN_CTB',
					'USE_PO_CONFIRMATIONS'
				], adminConfig.factory.id);

			var promiseTwo = factorySettingService.getDaysDisplay(adminConfig.factory.id);
			var promiseThree = shortageCriticalityLevelService.getShortageCriticalityLevelsGroupByLvl(adminConfig.factory.id);
			var promiseFour = customerSettingService.getCustomerSettings(['showCustomerOrderMetadata']);
			var promises = [promiseOne, promiseTwo, promiseThree];
			if (vm.isSuperAdmin) {
				promises.push(promiseFour);
			}
			$q.all(promises)
				.then(function (response) {
					var settings = response[0];
					vm.trimLeadingZeroes = settings.TRIM_LEADING_ZEROS ? 'Yes' : 'No';
					vm.leadTime = settings.PROCUREMENT_LEAD_TIME_DAYS;
					vm.receivingTime = settings.PROCUREMENT_RECEIVING_TIME_DAYS;
					vm.hideLeandnaActionColumn = settings.HIDE_LEANDNA_ACTION_COLUMN ? 'Yes' : 'No';
					vm.orderIntervalDisplay = response[1].daysDisplayType;
					vm.shortageByOrderReport = settings.SHORTAGE_BY_ORDER_REPORT;
					vm.shortageByOrderReportOnOff = settings.SHORTAGE_BY_ORDER_REPORT === 'None' ? 'Off' : 'On';
					vm.shortageByOrderGenerationType = settings.PROCUREMENT_GENERATE_SHORTAGE_BY_ORDER_REPORT;
					vm.shortageByOrderDataHorizonInMonths = settings.SHORTAGE_BY_ORDER_DATA_HORIZON;
					vm.additionalPeggingLogic = settings.ADDITIONAL_PEGGING_LOGIC;
					vm.excludePlannedSupply = settings.EXCLUDE_PR_AND_PPOS_FROM_SBO_PEGGING ? 'Yes' : 'No';
					vm.prRequestedDateIncludesReceivingTime = settings.PR_REQUESTED_DATE_INCLUDES_RECEIVING_TIME ? 'Yes' : 'No';
					vm.poRequestedDateIncludesReceivingTime = settings.PO_REQUESTED_DATE_INCLUDES_RECEIVING_TIME ? 'Yes' : 'No';
					vm.showCritcalityShortagesInBuyerEmail = settings.ONLY_INCLUDE_CRITICAL_SHORTAGES_IN_STANDARD_WORK_EMAIL;
					vm.disableUpdatingCommitDatesForDeliveredPOs = settings.DISABLE_UPDATING_COMMIT_DATES_FOR_DELIVERED_POS;
					vm.generateClearToBuild = settings.GENERATE_CLEAR_TO_BUILD ? 'Yes' : 'No';
					vm.generateClearToBuildFlattenedReqs = settings.GENERATE_CLEAR_TO_BUILD_FLATTENED_REQS ? 'Yes' : 'No';
					vm.clearToBuildHorizonField = settings.CLEAR_TO_BUILD_HORIZON_FIELD;
					vm.includingPRsInCTB = settings.INCLUDING_PRS_IN_CTB;
					vm.forceHardPegging = settings.FORCE_HARD_PEGGING;
					vm.firmBeforePlanned = settings.PEG_FIRM_BEFORE_PLANNED_CTB ? 'Yes' : 'No';
					vm.supplyDateToUseInCTB = settings.SUPPLY_DATE_TO_USE_IN_CTB;
					vm.manufacturedPartStatusInMultiLevelCTB = settings.MANUFACTURED_PART_STATUS_IN_MULTI_LEVEL_CTB;
					vm.clearToBuildWindowDays = settings.CLEAR_TO_BUILD_PERCENT_WINDOW_DAYS;
					vm.clearToCommitWindowDays = settings.CLEAR_TO_COMMIT_PERCENT_WINDOW_DAYS;
					vm.usePoConfirmations = settings.USE_PO_CONFIRMATIONS ? 'Yes' : 'No';
					if (response[2]) {
						vm.criticalityLvls = _.sortBy(_.values(response[2]), 'rank');
						for (var i = 1; i < vm.criticalityLvls.length; i++) {
							vm.criticalityLvls[i].label += ' and above';
						}
						vm.showShortageCriticalityLvls = vm.criticalityLvls.length;
					};

					if (vm.showShortageCriticalityLvls) {
						vm.criticalityLvls.unshift(noneLevel);
						setCurrentCriticalityLvl(settings.MAX_CRITICALITY_RANK_IN_SHORTAGES_KPI);
						setCriticalityTooltipData();
					}

					if (vm.isSuperAdmin) {
						var customerSettings = response[3];
						vm.showCustomerOrderMetadata = customerSettings.showCustomerOrderMetadata ? 'Yes' : 'No';
					}
				});
		}

		function setCriticalityTooltipData() {
			var criticalityLvls = vm.criticalityLvls.filter(function (lvl) { return lvl.rank != noneRank; });
			var htmlContent = '<table border="2px solid white" style="background-color:black;color:white;">' +
						'<tr>' +
						'<th style="text-align:left;padding:4px">Criticality Lvl</th>' +
						'<th style="text-align:left;padding:4px">Description</th>' +
						'</tr>';
			angular.forEach(criticalityLvls, function(lvl) {
				htmlContent += '<tr>' +
								'<td style="text-align:left;padding:4px;white-space:nowrap;">' + lvl.label + '</td>' +
								'<td style="text-align:left;padding:4px">' + lvl.description + '</td></tr>';
			});
			$scope.criticalityLvlTooltipData = $sce.trustAsHtml(htmlContent);
		}

		function getCriticalityRank(rank) {
			var actualMaxRank = vm.criticalityLvls[vm.criticalityLvls.length - 1].rank;
			switch(rank.toUpperCase()) {
			case 'MAX':
				return actualMaxRank;
			case noneRank:
				return rank;
			default:
				return parseInt(rank) > parseInt(actualMaxRank) ? actualMaxRank : rank;
			}
		}

		function getRankToSave() {
			var rankToSave = vm.kpiCriticalityLvl;
			if (rankToSave == undefined) {
				return 'MAX';
			}
			if (rankToSave.rank != undefined) {
				rankToSave = rankToSave.rank;
			}
			return rankToSave;
		}

		function setCurrentCriticalityLvl(rank) {
			var targetRank = getCriticalityRank(rank);
			vm.kpiCriticalityLvl = vm.criticalityLvls.find(function(lvl) {
				return lvl.rank == targetRank;
			});
		}

		function saveSettings() {
			var saveObj = {
				TRIM_LEADING_ZEROS: vm.trimLeadingZeroes === 'Yes',
				PROCUREMENT_LEAD_TIME_DAYS: vm.leadTime,
				PROCUREMENT_RECEIVING_TIME_DAYS: vm.receivingTime,
				SHORTAGE_BY_ORDER_REPORT: vm.shortageByOrderReportOnOff === 'On' ? 'Custom Tabular Report (New)' : 'None',
				ADDITIONAL_PEGGING_LOGIC: vm.additionalPeggingLogic,
				EXCLUDE_PR_AND_PPOS_FROM_SBO_PEGGING: vm.excludePlannedSupply === 'Yes',
				PROCUREMENT_GENERATE_SHORTAGE_BY_ORDER_REPORT: vm.shortageByOrderGenerationType,
				SHORTAGE_BY_ORDER_DATA_HORIZON: vm.shortageByOrderDataHorizonInMonths,
				PR_REQUESTED_DATE_INCLUDES_RECEIVING_TIME: vm.prRequestedDateIncludesReceivingTime === 'Yes',
				PO_REQUESTED_DATE_INCLUDES_RECEIVING_TIME: vm.poRequestedDateIncludesReceivingTime === 'Yes',
				HIDE_LEANDNA_ACTION_COLUMN: vm.hideLeandnaActionColumn === 'Yes',
				ONLY_INCLUDE_CRITICAL_SHORTAGES_IN_STANDARD_WORK_EMAIL: vm.showCritcalityShortagesInBuyerEmail ? 1 : 0,
				DISABLE_UPDATING_COMMIT_DATES_FOR_DELIVERED_POS: vm.disableUpdatingCommitDatesForDeliveredPOs ? 1 : 0,
				USE_PO_CONFIRMATIONS: vm.usePoConfirmations === 'Yes'
			};
			if (vm.showShortageCriticalityLvls) {
				saveObj.MAX_CRITICALITY_RANK_IN_SHORTAGES_KPI = getRankToSave();
			}
			if (vm.isSuperAdmin) {
				saveObj.GENERATE_CLEAR_TO_BUILD = vm.generateClearToBuild === 'Yes';
				saveObj.GENERATE_CLEAR_TO_BUILD_FLATTENED_REQS = vm.generateClearToBuildFlattenedReqs === 'Yes';
				saveObj.FORCE_HARD_PEGGING = vm.forceHardPegging === true;
			}

			saveObj.PEG_FIRM_BEFORE_PLANNED_CTB = vm.firmBeforePlanned === 'Yes';
			saveObj.CLEAR_TO_BUILD_HORIZON_FIELD = vm.clearToBuildHorizonField;
			saveObj.INCLUDING_PRS_IN_CTB = vm.includingPRsInCTB;
			saveObj.CLEAR_TO_BUILD_PERCENT_WINDOW_DAYS = vm.clearToBuildWindowDays;
			saveObj.CLEAR_TO_COMMIT_PERCENT_WINDOW_DAYS = vm.clearToCommitWindowDays;
			saveObj.MANUFACTURED_PART_STATUS_IN_MULTI_LEVEL_CTB = vm.manufacturedPartStatusInMultiLevelCTB;
			saveObj.SUPPLY_DATE_TO_USE_IN_CTB = vm.supplyDateToUseInCTB;

			var promiseOne = factorySettingService.saveFactorySettings(saveObj, adminConfig.factory.id);
			var promiseTwo = factorySettingService.saveDaysDisplay(adminConfig.factory.id, vm.orderIntervalDisplay);

			var savePromises = [promiseOne, promiseTwo];
			var shouldSaveCustomerSetting = vm.isSuperAdmin && vm.generateClearToBuildFlattenedReqs === 'Yes';
			if (shouldSaveCustomerSetting) {
				var customerSettingsToSave = { 'showCustomerOrderMetadata': vm.showCustomerOrderMetadata === 'Yes' };
				var promise3 = customerSettingService.saveCustomerSettings(customerSettingsToSave, adminConfig.factory.id);
				savePromises.push(promise3);
			}

			$q.all(savePromises)
				.then(function (responseList) {
					var responseOne = responseList[0];
					var responseTwo = responseList[1];
					var responseThree = shouldSaveCustomerSetting ? responseList[2] : 'Settings saved successfully';
					if (responseOne === 'Settings saved successfully' && responseTwo === 'Settings saved successfully' && responseThree === 'Settings saved successfully') {
						$rootScope.$emit('toast', {
							'message': responseOne,
							'success': true
						});
						if (globalConfig.factory.id === adminConfig.factory.id) {
							if (globalConfig.factory.shortageByOrderReport !== vm.shortageByOrderReport) {
								globalConfig.factory.shortageByOrderReport = vm.shortageByOrderReport;
							}
						}
					} else {
						$rootScope.$emit('toast', {
							'message': 'There was an error saving results, please try again',
							'success': false
						});
					}
				});
		}

		function validate() {
			if (typeof vm.leadTime !== 'number') {
				return false;
			}
			if (typeof vm.receivingTime !== 'number') {
				return false;
			}
			return true;
		}
	}
});
